const KeyValuedetails = ({title,value}) => {
  return (
    <div className="flex items-center gap-x-2">
        <p className="text-base font-semibold ">{title} :</p>
        <p className="flex-1 truncate text-sm font-medium ">{value}</p>
    </div>
  )
}
export default KeyValuedetails